import React, { useEffect, useRef, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Zoom } from "swiper/modules";
import "swiper/css/bundle";

const prefix = `https://api.onlybrands.ge/storage/`;

const ImageModal = ({ images, imageUrl, onClose }) => {
  const [mainImage, setMainImage] = useState(imageUrl);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current?.swiper && imageUrl) {
      const newIndex = images.indexOf(imageUrl);
      swiperRef.current.swiper.slideTo(newIndex);
    }

    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [imageUrl, images]);

  const handleThumbnailClick = (img) => {
    const index = images.indexOf(img);
    setMainImage(img);
    if (swiperRef.current?.swiper) {
      swiperRef.current.swiper.slideTo(index);
    }
  };

  const handlePrev = () => {
    swiperRef.current?.swiper?.slidePrev();
  };

  const handleNext = () => {
    swiperRef.current?.swiper?.slideNext();
  };

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col md:flex-row items-center justify-center bg-white bg-opacity-90 p-4 overflow-hidden">
      <button
        onClick={onClose}
        className="absolute top-5 right-5 p-2 bg-white text-black rounded-full hover:scale-110 transition"
      >
        <IoMdClose className="h-5 w-5" />
      </button>

      {/* Thumbnails */}
      <div className="flex md:flex-col gap-3 items-center justify-center w-full md:w-auto mb-4 md:mb-0">
        {images.map((img, index) => (
          <button
            key={index}
            onClick={() => handleThumbnailClick(img)}
            className={`p-1 rounded-md overflow-hidden ${mainImage === img
                ? "border-2 border-orange-500"
                : "border border-gray-300"
              }`}
          >
            <img
              src={prefix + img}
              alt={`Thumb ${index}`}
              className="h-[60px] w-[60px] md:h-[80px] md:w-[80px] object-cover hover:scale-105 transition-transform duration-150"
            />
          </button>
        ))}
      </div>

      {/* Swiper */}
      <div className="relative w-full md:w-[70%] h-[70vh] md:h-[95vh] bg-white rounded-md p-2">
        <Swiper
          ref={swiperRef}
          modules={[Zoom, Navigation, Pagination]}
          zoom={true}
          navigation={false}
          pagination={{ clickable: true }}
          spaceBetween={10}
          slidesPerView={1}
          loop={true}
          onSlideChange={(swiper) => {
            const current = images[swiper.realIndex];
            setMainImage(current);
          }}
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <div className="swiper-zoom-container w-full h-full flex items-center justify-center">
                <img
                  src={prefix + image}
                  alt={`Zoomed ${index}`}
                  className="w-auto h-auto max-h-[80vh] max-w-full object-contain md:max-h-[90vh] md:max-w-[90%] md:rounded-[12px]"
                  loading="lazy"
                />
              </div>
            </SwiperSlide>

          ))}
        </Swiper>

        {/* Arrows */}
        <button
          onClick={handlePrev}
          className="absolute left-5 opacity-0 top-1/2 transform -translate-y-1/2 p-3 bg-white text-orange-500 border border-orange-500 rounded-full text-4xl hover:bg-orange-100 z-50"
        >
          &#10094;
        </button>
        <button
          onClick={handleNext}
          className="absolute right-5 opacity-0 top-1/2 transform -translate-y-1/2 p-3 bg-white text-orange-500 border border-orange-500 rounded-full text-4xl hover:bg-orange-100 z-50"
        >
          &#10095;
        </button>
      </div>
    </div>
  );
};

export default ImageModal;
